import axiosClient from "../axiosClient";

export const licensePlateWatchlistAPI = {
    getWatchlist: (params) => {
        return axiosClient.get(`anprMonitor/get-list-anpr-monitor/`, { params });
    },
    addLicensePlate: (licensePlate) => {
        return axiosClient.post(`anprMonitor/post-add-anpr-monitor/`,  licensePlate );
    },
    updateLicensePlate: (code, licensePlate) => {
        return axiosClient.put(`anprMonitor/put-change-anpr-monitor/?code=${code}`,  licensePlate );
    },
    deleteLicensePlate: (code) => {
        return axiosClient.delete(`anprMonitor/delete-remove-anpr-monitor/?code=${code}`);
    }
};